import React from "react";
import { Link } from "react-router-dom";

function Breadcrump({ title, middle = "" }) {
  return (
    <section className="custom-breadcrumb">
      <div className="container">

        <div className="custom-breadcrumb-inner">

          <h2 className="custom-breadcrumb-title">{title}</h2>

          <div className="custom-breadcrumb-path">
            <Link to="/">Home</Link>

            {middle && (
              <>
                <span>/</span>
                <Link to={`/${middle.toLowerCase()}`}>{middle}</Link>
              </>
            )}

            <span>/</span>
            <span className="active">{title}</span>
          </div>

        </div>

      </div>
    </section>
  );
}

export default Breadcrump;
